import type { FC } from "react";
import { Icon } from "../../shared/components/Icon/Icon";
import { IconNames } from "../../shared/components/Icon/svg";
import classes from "./Partners.module.scss";
import { v4 as uuidv4 } from "uuid";

export const Partners: FC = () => {
	const partners: IconNames[] = [
		"unqork",
		"visa",
		"ness",
		"safety_wing",
		"identity",
		"stitch",
		"okra",
		"vital",
		"resly",
		"humaans",
	];

	return (
		<div className={classes.wrapper}>
			<h2 className={classes.title}>Our partners</h2>
			<span className={classes.text}>Some smaller text below the title</span>
			<div className={classes.content}>
				{partners.map(partner => (
					<Icon key={uuidv4()} className={classes.partner} name={partner} />
				))}
			</div>
		</div>
	);
};
